import {
  getFileBlobFromServer,
  uploadFileToBlob,
} from "configs/AzureStorageBlobFile";
import heic2any from "heic2any";
import imageCompression from "browser-image-compression";

export const UploadFile = async (fileTemp) => {
  const optionsCompress = {
    maxSizeMB: 0.5,
    useWebWorker: true,
  };
  // update avatar to blob storage --> get link
  if (
    fileTemp.type === "image/heic" ||
    fileTemp.type === "image/heif" ||
    fileTemp.name.includes(".heif") ||
    fileTemp.name.includes(".heic")
  ) {
    try {
      const blob = await heic2any({ blob: fileTemp, toType: "image/jpeg" });

      // Convert Blob to File
      const jpgFile = new File([blob], "converted-image.jpg", {
        type: "image/jpeg",
        lastModified: Date.now(),
      });
      const compressedFile = await imageCompression(jpgFile, optionsCompress);
      const blobsInContainer = await uploadFileToBlob(compressedFile);

      return blobsInContainer;
    } catch (error) {
      console.error("HEIC to JPG conversion failed:", error);
    }
  } else {
    const compressedFile = await imageCompression(fileTemp, optionsCompress);
    const blobsInContainer = await uploadFileToBlob(compressedFile);
    return blobsInContainer;
  }
};

export const GetFile = async (fileName) => {
  const blobsInContainer = await getFileBlobFromServer(fileName);
  return blobsInContainer;
};
